import { WecahtUserInfo } from "@/wx/WXLogin";

export class UserData {
  token = "";
  expiresAt = 0;
  name = "";
  avatar = "";
  redirectUrl = "";
}

export interface UserDataModel {
  userInfo: UserDataUserInfo;
  accessToken: UserDataAccessToken;
}

export interface UserDataUserInfo {
  avatar: string;
  createdAt: string;
  invitationCode: "";
  isFirst: string;
  name: string;
}

export interface UserDataAccessToken {
  accessToken: string;
  expiresAt: number;
  redirectUrl: string;
}

export class UserLocalStorage {
  private static uuid = "tanabataUuid";
  private static openid = "tanabataoOpenid";
  private static authorizeOpenid = "tanabataOpenid";
  private static wx_unionid = "tanabataOpenid";
  private static accessToken = "tanabataAccessToken";
  private static username = "tanabataUsername";
  private static avatar = "tanabataAvatar";
  private static expiresAt = "tanabataExpiresAt";

  static getName(): string {
    if (localStorage != null && localStorage.getItem(this.username) != null) {
      return localStorage.getItem(this.username) ?? "";
    }
    return "";
  }

  static getAccessToken(): string {
    if (
      localStorage != null &&
      localStorage.getItem(this.accessToken) != null
    ) {
      return localStorage.getItem(this.accessToken) ?? "";
    }
    return "";
  }

  static getAvatar(): string {
    if (localStorage != null && localStorage.getItem(this.avatar) != null) {
      return localStorage.getItem(this.avatar) ?? "";
    }
    return "";
  }

  static getExpiresAt(): string {
    if (localStorage != null && localStorage.getItem(this.expiresAt) != null) {
      return localStorage.getItem(this.expiresAt) ?? "";
    }
    return "";
  }

  static getData(data: UserData): UserData {
    data.token = this.getAccessToken();
    data.avatar = this.getAvatar();
    data.name = this.getName();
    data.expiresAt = Number(this.getExpiresAt());
    return data;
  }

  static getWXOpenId() {
    if (localStorage != null && localStorage.getItem(this.openid) != null) {
      return localStorage.getItem(this.openid) ?? "";
    }
    return "";
  }

  static setWXOpenid(openid: string) {
    if (openid == null) return;
    localStorage.setItem(this.openid, openid);
  }

  
  static getWXAuthorizeOpenId() {
    if (localStorage != null && localStorage.getItem(this.authorizeOpenid) != null) {
      return localStorage.getItem(this.authorizeOpenid) ?? "";
    }
    return "";
  }

  static setWXAuthorizeOpenid(openid: string) {
    if (openid == null) return;
    localStorage.setItem(this.authorizeOpenid, openid);
  }

  static setUserData(data: UserData) {
    if (data == null) return;
    localStorage.setItem(this.accessToken, data.token);
    localStorage.setItem(this.username, data.name);
    localStorage.setItem(this.avatar, data.avatar);
    localStorage.setItem(this.expiresAt, data.expiresAt.toString());
  }

  static setWXUserData(data: WecahtUserInfo) {
    if (data == null) return;
    localStorage.setItem(this.openid, data.openid);
    localStorage.setItem(this.wx_unionid, data.unionid);
    localStorage.setItem(this.avatar, data.headimgurl);
    localStorage.setItem(this.username, data.nickname);
  }

  static clearLocalStorage() {
    localStorage.setItem(this.accessToken, "");
    localStorage.setItem(this.username, "");
    localStorage.setItem(this.avatar, "");
    localStorage.setItem(this.expiresAt, "");
    localStorage.clear();
  }

  static getUUID() {
    if (localStorage.getItem(this.uuid) != null) {
      return localStorage.getItem(this.uuid) ?? this.getuuid();
    }
    const uuid = this.getuuid();
    localStorage.setItem(this.uuid, uuid);
    return uuid;
  }
  // 获取uuid
  static getuuid(): string {
    const s = [];
    const hexDigits = "0123456789abcdef";
    for (let i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((Number(s[19]) & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";
    const uuid = s.join("");
    return uuid;
  }
}
